module.exports = __webpack_public_path__ + "images/illustrations/icons/icon-chat-bubbles-992457ea56376ba283fcab138d7cfac4.webp";